import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { UserState } from 'src/app/_shared/state/user.state';
import { AppState } from 'src/app/app.state';
import { CmaState } from '../cma.state';

@Component({
  selector: 'app-cma-reports-filter',
  templateUrl: './cma-reports-filter.component.html',
  styleUrls: ['./cma-reports-filter.component.scss'],
})
export class CmaReportsFilterComponent implements OnInit {
  @Output() sortProperties = new EventEmitter<string>();

  cmaReportFilterForm: FormGroup;
  initialValues: {};
  onDestroyNotifier$ = new Subject();
  reportTypes = [];
  allReportTypes = [
    { value: 'all', label: 'All' },
    { value: 'instantCMA', label: 'Instant CMA' },
    { value: 'customCMA', label: 'Custom CMA' },
    { value: 'leadCMA', label: 'Lead CMA' },
  ];
  statusOptions = [
    { value: 'all', label: 'All' },
    { value: 'created', label: 'Success' },
    { value: 'failed', label: 'Failed' },
  ];
  isCoBrandedByMe: boolean = false;
  userRole: string;
  companyAlias: any;

  constructor(private formBuilder: FormBuilder,private appState:AppState,private userState: UserState, private cmaState: CmaState) {}

  ngOnInit(): void {
    this.userState.userDetail$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((res) => {
      if (res) {
        if (res?.roles?.length > 0) {
          this.userRole = res.roles[0];
          this.reportTypes = this.allReportTypes;
        }
      }
    });
    this.companyAlias = this.appState.companyInfoValue.alias;
    this.cmaReportFilterForm = this.formBuilder.group({
      reportCategory: ['all'],
      status: ['all'],
      coBrandedWithMe: [false],
      searchAddress:''
    });
    this.initialValues = this.cmaReportFilterForm.value;

    if (this.cmaState?.filterValValue?.coBrandedWithMe) {
      this.isCoBrandedByMe = true;
      this.cmaReportFilterForm.patchValue({ coBrandedWithMe: true });
    } else {
      this.isCoBrandedByMe = false;
      this.cmaReportFilterForm.patchValue({ coBrandedWithMe: false });
    }

    if (this.cmaState?.filterValValue?.reportCategory && this.cmaState?.filterValValue?.reportCategory?.length) {
      this.cmaReportFilterForm.patchValue({ reportCategory: this.cmaState.filterValValue.reportCategory });
    } else {
      this.cmaReportFilterForm.patchValue({ reportCategory: 'all' });
    }

    if (this.cmaState?.filterValValue?.status && this.cmaState?.filterValValue?.status?.length) {
      this.cmaReportFilterForm.patchValue({ status: this.cmaState.filterValValue.status[0] });
    } else {
      this.cmaReportFilterForm.patchValue({ status: 'all' });
    }
  }

  filterBtn() {
    this.sortProperties.emit(this.cmaReportFilterForm.value);
  }

  resetReportsFilter() {
    this.cmaReportFilterForm.reset(this.initialValues);
    this.isCoBrandedByMe = false;
    this.filterBtn();
  }

  coBrandedWithMe() {
    this.isCoBrandedByMe = !this.isCoBrandedByMe;
    if (this.isCoBrandedByMe) {
      this.cmaReportFilterForm.patchValue({ coBrandedWithMe: true });
    } else {
      this.cmaReportFilterForm.patchValue({ coBrandedWithMe: false });
    }
    this.filterBtn();
  }

  ngOnDestroy(): void {
    this.onDestroyNotifier$.next();
    this.onDestroyNotifier$.complete();
  }
}
